import React, { useContext } from 'react';

import i18nContext from '@components/i18n/i18nContext';
import { filterNodesByLangcode } from '@helpers/languages';

const DEFAULT_LANGCODE = 'en';

export function useSidebarNavigation() {
  const { lng } = useContext(i18nContext);
  const langcode = lng || DEFAULT_LANGCODE;

  const result = {
    allMenuLinkContentMenuLinkContent: {
      edges: [
        {
          node: {
            title: 'Group 1',
            link: {
              options: {
                attributes: null,
              },
              uri_alias: 'route:<nolink>',
              title: '',
              uri: 'route:<nolink>',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 0,
            drupal_id: '5ca1e8eb-65d1-4621-a059-acb8653d2a99',
            drupal_parent_menu_item: null,
          },
        },
        {
          node: {
            title: 'Group 2',
            link: {
              options: {
                attributes: null,
              },
              uri_alias: 'route:<nolink>',
              title: '',
              uri: 'route:<nolink>',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 1,
            drupal_id: '8f7a8cdb-52e1-4ebe-86f7-0b77c2aca153',
            drupal_parent_menu_item: null,
          },
        },
        {
          node: {
            title: 'Group 3',
            link: {
              options: {
                attributes: null,
              },
              uri_alias: 'route:<nolink>',
              title: '',
              uri: 'route:<nolink>',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 2,
            drupal_id: '2c6a2fbd-f076-4af4-bc9b-e314c2078dd8',
            drupal_parent_menu_item: null,
          },
        },
        {
          node: {
            title: 'Group 4',
            link: {
              options: {
                attributes: null,
              },
              uri_alias: 'route:<nolink>',
              title: '',
              uri: 'route:<nolink>',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 3,
            drupal_id: '1ad280f6-2173-4ddc-999d-4b7f0ff0da52',
            drupal_parent_menu_item: null,
          },
        },
        {
          node: {
            title: 'Group 5',
            link: {
              options: {
                attributes: null,
              },
              uri_alias: 'route:<nolink>',
              title: '',
              uri: 'route:<nolink>',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 4,
            drupal_id: '6b4e7206-e25c-4a67-af7d-572b935ffde2',
            drupal_parent_menu_item: null,
          },
        },
        {
          node: {
            title: 'Lucid Air',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/air/',
              title: '',
              uri: 'internal:/air',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 0,
            drupal_id: '9dc52a74-08c2-42ed-9a23-6c276b21329e',
            drupal_parent_menu_item:
              'menu_link_content:8f7a8cdb-52e1-4ebe-86f7-0b77c2aca153',
          },
        },
        {
          node: {
            title: 'More about Lucid',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: 'route:<nolink>',
              title: '',
              uri: 'route:<nolink>',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 0,
            drupal_id: 'f4c94f5e-0490-432b-bd72-2624a6f26652',
            drupal_parent_menu_item:
              'menu_link_content:2c6a2fbd-f076-4af4-bc9b-e314c2078dd8',
          },
        },
        {
          node: {
            title: 'Company',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: 'route:<nolink>',
              title: '',
              uri: 'route:<nolink>',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 1,
            drupal_id: '890ea76f-a6aa-46a2-bfca-87b6dad8ed5c',
            drupal_parent_menu_item:
              'menu_link_content:2c6a2fbd-f076-4af4-bc9b-e314c2078dd8',
          },
        },
        {
          node: {
            title: 'Legal',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/legal/',
              title: '',
              uri: 'internal:/legal',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 1,
            drupal_id: '309e1c8c-5153-43c6-9ea3-d536d25e4a5e',
            drupal_parent_menu_item:
              'menu_link_content:6b4e7206-e25c-4a67-af7d-572b935ffde2',
          },
        },
        {
          node: {
            title: 'Sign In',
            link: {
              options: {
                attributes: {
                  type: 'auth',
                  ifUser: 'hide',
                  ifSidebar: 'show',
                  ifMainNav: 'show',
                },
              },
              uri_alias: 'portal/login/',
              title: '',
              uri: 'internal:/portal/login/',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 0,
            drupal_id: '4da7be9b-95e0-4839-8665-e6f5cd6284b5',
            drupal_parent_menu_item:
              'menu_link_content:5ca1e8eb-65d1-4621-a059-acb8653d2a99',
          },
        },
        {
          node: {
            title: 'Overview',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/air/',
              title: '',
              uri: 'internal:/air',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 0,
            drupal_id: 'd9468a26-c750-49a0-9b10-6e5409ca0aa4',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            title: 'Design',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: 'air/design/',
              title: '',
              uri: 'internal:/air/design',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 1,
            drupal_id: 'ba4e7a33-7871-406e-b25e-c58dd304f53a',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            title: 'Charging',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/charging/',
              title: '',
              uri: 'internal:/charging',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 3,
            drupal_id: 'ff275cd6-ebde-47a1-9364-f7a975da5996',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            title: 'Performance',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: 'air/performance/',
              title: '',
              uri: 'internal:/air/performance',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 2,
            drupal_id: '7b89f3bf-7277-412e-91d0-29b980f2bd8d',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            title: 'Connectivity',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: 'air/connectivity/',
              title: '',
              uri: 'internal:/air/connectivity',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 4,
            drupal_id: 'fc3e6ba6-447c-460e-bcce-c7921407b834',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            title: 'Specs',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: 'air/specs/',
              title: '',
              uri: 'internal:/air/specs',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 5,
            drupal_id: 'abead162-0e54-40b7-8dcd-7d076cc9a9c2',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            title: 'Dream Edition',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: 'air/dream-edition/',
              title: '',
              uri: 'internal:/air/dream-edition',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 6,
            drupal_id: '9f22f244-b91b-43fb-b25e-81932ca46c75',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            title: 'Reserve',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: 'air/reserve/',
              title: '',
              uri: 'internal:/air/reserve',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 2,
            drupal_id: '161eb1b4-5727-48f6-882b-dbdf8734f988',
            drupal_parent_menu_item:
              'menu_link_content:8f7a8cdb-52e1-4ebe-86f7-0b77c2aca153',
          },
        },
        {
          node: {
            title: 'Stories',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/stories/',
              title: '',
              uri: 'internal:/stories',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 3,
            drupal_id: '224c0dc8-f91e-49a4-9a1f-d2b096313f3d',
            drupal_parent_menu_item:
              'menu_link_content:2c6a2fbd-f076-4af4-bc9b-e314c2078dd8',
          },
        },
        {
          node: {
            title: 'Race-proven Performance',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/race-proven/',
              title: '',
              uri: 'internal:/race-proven',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 0,
            drupal_id: '58b9d8cc-4ca4-4076-9999-b2ff5c81f128',
            drupal_parent_menu_item:
              'menu_link_content:f4c94f5e-0490-432b-bd72-2624a6f26652',
          },
        },
        {
          node: {
            title: 'Purchase & Ownership',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/ownership/',
              title: '',
              uri: 'internal:/ownership',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 1,
            drupal_id: 'e43609a4-ae62-44f2-b9e8-f031e31c8ee1',
            drupal_parent_menu_item:
              'menu_link_content:f4c94f5e-0490-432b-bd72-2624a6f26652',
          },
        },
        {
          node: {
            title: 'Project Gravity',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/future-models/',
              title: '',
              uri: 'internal:/future-models',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 2,
            drupal_id: '0d82a0b8-b724-4b30-bada-6fd1a0ba32b5',
            drupal_parent_menu_item:
              'menu_link_content:f4c94f5e-0490-432b-bd72-2624a6f26652',
          },
        },
        {
          node: {
            title: 'FAQ',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/faq/',
              title: '',
              uri: 'internal:/faq',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 3,
            drupal_id: 'd33ab6ec-6d42-4e92-bc32-afa4b9ee1f50',
            drupal_parent_menu_item:
              'menu_link_content:f4c94f5e-0490-432b-bd72-2624a6f26652',
          },
        },
        {
          node: {
            title: 'Leadership',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: 'company/leadership/',
              title: '',
              uri: 'internal:/company/leadership',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 1,
            drupal_id: '63251eb3-79c0-40d6-8d4d-97d18b6d23d3',
            drupal_parent_menu_item:
              'menu_link_content:890ea76f-a6aa-46a2-bfca-87b6dad8ed5c',
          },
        },
        {
          node: {
            title: 'Sustainability',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/sustainability/',
              title: '',
              uri: 'internal:/sustainability',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 2,
            drupal_id: 'b75be3b3-7955-4a53-ab16-a05540ae61ea',
            drupal_parent_menu_item:
              'menu_link_content:890ea76f-a6aa-46a2-bfca-87b6dad8ed5c',
          },
        },
        {
          node: {
            title: 'Investors',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: 'https://ir.lucidmotors.com',
              title: '',
              uri: 'https://ir.lucidmotors.com',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 2,
            drupal_id: '9c26bca7-78a1-44d3-9d5c-658b6f45fa32',
            drupal_parent_menu_item:
              'menu_link_content:2c6a2fbd-f076-4af4-bc9b-e314c2078dd8',
          },
        },
        {
          node: {
            title: 'My Account',
            link: {
              options: {
                attributes: {
                  type: 'auth',
                  ifUser: 'show',
                  ifSidebar: 'show',
                  ifMainNav: 'show',
                },
              },
              uri_alias: 'portal/reservations/',
              title: '',
              uri: 'internal:/portal/reservations/',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 1,
            drupal_id: '7efc65bc-9d71-4687-94e1-457ac5f04ab5',
            drupal_parent_menu_item:
              'menu_link_content:5ca1e8eb-65d1-4621-a059-acb8653d2a99',
          },
        },
        {
          node: {
            title: 'Sign Out',
            link: {
              options: {
                attributes: {
                  type: 'auth',
                  ifUser: 'show',
                  ifSidebar: 'show',
                  ifMainNav: 'hide',
                },
              },
              uri_alias: 'portal/logout/',
              title: '',
              uri: 'internal:/portal/logout/',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 2,
            drupal_id: '190c7950-d78c-4001-aa75-af2193e488e8',
            drupal_parent_menu_item:
              'menu_link_content:5ca1e8eb-65d1-4621-a059-acb8653d2a99',
          },
        },
        {
          node: {
            title: 'Events',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/events/',
              title: '',
              uri: 'internal:/events',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 2,
            drupal_id: '03ef38ad-586f-4afa-8679-d05a9db6a7d2',
            drupal_parent_menu_item:
              'menu_link_content:1ad280f6-2173-4ddc-999d-4b7f0ff0da52',
          },
        },
        {
          node: {
            title: 'Careers',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/careers/',
              title: '',
              uri: 'internal:/careers',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 4,
            drupal_id: '14da123d-a711-4103-b9ed-bbf48721493f',
            drupal_parent_menu_item:
              'menu_link_content:2c6a2fbd-f076-4af4-bc9b-e314c2078dd8',
          },
        },
        {
          node: {
            title: 'Contact',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/contact/',
              title: '',
              uri: 'internal:/contact',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 0,
            drupal_id: 'dd03d8cd-32b6-4463-802e-1388b982aa1a',
            drupal_parent_menu_item:
              'menu_link_content:1ad280f6-2173-4ddc-999d-4b7f0ff0da52',
          },
        },
        {
          node: {
            title: 'Locations',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/locations/',
              title: '',
              uri: 'internal:/locations',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 1,
            drupal_id: '7906b581-669a-469b-a9f1-5a58cba21b34',
            drupal_parent_menu_item:
              'menu_link_content:1ad280f6-2173-4ddc-999d-4b7f0ff0da52',
          },
        },
        {
          node: {
            title: 'Media Room',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/media-room/',
              title: '',
              uri: 'internal:/media-room',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 0,
            drupal_id: '790a49d8-3e7e-479d-9570-b03d80763e8f',
            drupal_parent_menu_item:
              'menu_link_content:6b4e7206-e25c-4a67-af7d-572b935ffde2',
          },
        },
        {
          node: {
            title: 'About Us',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/company/',
              title: '',
              uri: 'internal:/company',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 0,
            drupal_id: 'a6c06a9d-65fa-4ebf-ae1b-cf2f08bfbb49',
            drupal_parent_menu_item:
              'menu_link_content:890ea76f-a6aa-46a2-bfca-87b6dad8ed5c',
          },
        },
        {
          node: {
            title: 'Stay Updated',
            link: {
              options: {
                attributes: {
                  type: 'button',
                  ifUser: 'show',
                  ifSidebar: 'show',
                  ifMainNav: 'show',
                },
              },
              uri_alias: '/subscribe/',
              title: '',
              uri: 'internal:/subscribe',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 3,
            drupal_id: '3eca708b-8ee5-4fa8-808e-659e76634752',
            drupal_parent_menu_item:
              'menu_link_content:5ca1e8eb-65d1-4621-a059-acb8653d2a99',
          },
        },
        {
          node: {
            title: 'Design Yours',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: 'air/configure/',
              title: '',
              uri: 'internal:/air/configure',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 1,
            drupal_id: '0fe4947c-18ce-499a-a0fe-a26d4af5a901',
            drupal_parent_menu_item:
              'menu_link_content:8f7a8cdb-52e1-4ebe-86f7-0b77c2aca153',
          },
        },
        {
          node: {
            title: 'Store',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: 'https://store.lucidmotors.com/',
              title: '',
              uri: 'https://store.lucidmotors.com/',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'en',
            weight: 3,
            drupal_id: '7528a84b-0bd6-445c-af33-c0da5b22c81f',
            drupal_parent_menu_item:
              'menu_link_content:1ad280f6-2173-4ddc-999d-4b7f0ff0da52',
          },
        },
        {
          node: {
            title: 'لوسِد أير',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/ar/air/',
              title: '',
              uri: 'internal:/air',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 0,
            drupal_id: '9dc52a74-08c2-42ed-9a23-6c276b21329e',
            drupal_parent_menu_item:
              'menu_link_content:8f7a8cdb-52e1-4ebe-86f7-0b77c2aca153',
          },
        },
        {
          node: {
            title: 'المزيد عن لوسِد',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: 'route:<nolink>',
              title: '',
              uri: 'route:<nolink>',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 0,
            drupal_id: 'f4c94f5e-0490-432b-bd72-2624a6f26652',
            drupal_parent_menu_item:
              'menu_link_content:2c6a2fbd-f076-4af4-bc9b-e314c2078dd8',
          },
        },
        {
          node: {
            title: 'الشركة',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: 'route:<nolink>',
              title: '',
              uri: 'route:<nolink>',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 1,
            drupal_id: '890ea76f-a6aa-46a2-bfca-87b6dad8ed5c',
            drupal_parent_menu_item:
              'menu_link_content:2c6a2fbd-f076-4af4-bc9b-e314c2078dd8',
          },
        },
        {
          node: {
            title: 'قانوني',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/ar/legal/',
              title: '',
              uri: 'internal:/legal',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 1,
            drupal_id: '309e1c8c-5153-43c6-9ea3-d536d25e4a5e',
            drupal_parent_menu_item:
              'menu_link_content:6b4e7206-e25c-4a67-af7d-572b935ffde2',
          },
        },
        {
          node: {
            title: 'دخول',
            link: {
              options: {
                attributes: {
                  type: 'auth',
                  ifUser: 'hide',
                  ifSidebar: 'show',
                  ifMainNav: 'show',
                },
              },
              uri_alias: '/arportal/login/',
              title: '',
              uri: 'internal:/portal/login/',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 0,
            drupal_id: '4da7be9b-95e0-4839-8665-e6f5cd6284b5',
            drupal_parent_menu_item:
              'menu_link_content:5ca1e8eb-65d1-4621-a059-acb8653d2a99',
          },
        },
        {
          node: {
            title: 'نظرة عامة',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/ar/air/',
              title: '',
              uri: 'internal:/air',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 0,
            drupal_id: 'd9468a26-c750-49a0-9b10-6e5409ca0aa4',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            title: 'صمم',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/arair/design/',
              title: '',
              uri: 'internal:/air/design',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 1,
            drupal_id: 'ba4e7a33-7871-406e-b25e-c58dd304f53a',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            title: 'الشحن',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/ar/charging/',
              title: '',
              uri: 'internal:/charging',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 3,
            drupal_id: 'ff275cd6-ebde-47a1-9364-f7a975da5996',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            title: 'الأداء',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/arair/performance/',
              title: '',
              uri: 'internal:/air/performance',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 2,
            drupal_id: '7b89f3bf-7277-412e-91d0-29b980f2bd8d',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            title: 'الإتصال',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/arair/connectivity/',
              title: '',
              uri: 'internal:/air/connectivity',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 4,
            drupal_id: 'fc3e6ba6-447c-460e-bcce-c7921407b834',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            title: 'المواصفات',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/arair/specs/',
              title: '',
              uri: 'internal:/air/specs',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 5,
            drupal_id: 'abead162-0e54-40b7-8dcd-7d076cc9a9c2',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            title: 'إصدار أير دريم',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/arair/dream-edition/',
              title: '',
              uri: 'internal:/air/dream-edition',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 6,
            drupal_id: '9f22f244-b91b-43fb-b25e-81932ca46c75',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            title: 'الحجز',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/arair/reserve/',
              title: '',
              uri: 'internal:/air/reserve',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 2,
            drupal_id: '161eb1b4-5727-48f6-882b-dbdf8734f988',
            drupal_parent_menu_item:
              'menu_link_content:8f7a8cdb-52e1-4ebe-86f7-0b77c2aca153',
          },
        },
        {
          node: {
            title: 'مدونات',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/ar/stories/',
              title: '',
              uri: 'internal:/stories',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 3,
            drupal_id: '224c0dc8-f91e-49a4-9a1f-d2b096313f3d',
            drupal_parent_menu_item:
              'menu_link_content:2c6a2fbd-f076-4af4-bc9b-e314c2078dd8',
          },
        },
        {
          node: {
            title: 'تكنولوجيا اختبرت في السباقات',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/ar/race-proven/',
              title: '',
              uri: 'internal:/race-proven',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 0,
            drupal_id: '58b9d8cc-4ca4-4076-9999-b2ff5c81f128',
            drupal_parent_menu_item:
              'menu_link_content:f4c94f5e-0490-432b-bd72-2624a6f26652',
          },
        },
        {
          node: {
            title: 'تجربة الشراء والتملك',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/ar/ownership/',
              title: '',
              uri: 'internal:/ownership',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 1,
            drupal_id: 'e43609a4-ae62-44f2-b9e8-f031e31c8ee1',
            drupal_parent_menu_item:
              'menu_link_content:f4c94f5e-0490-432b-bd72-2624a6f26652',
          },
        },
        {
          node: {
            title: 'جرافيتي بروجيكت',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/ar/future-models/',
              title: '',
              uri: 'internal:/future-models',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 2,
            drupal_id: '0d82a0b8-b724-4b30-bada-6fd1a0ba32b5',
            drupal_parent_menu_item:
              'menu_link_content:f4c94f5e-0490-432b-bd72-2624a6f26652',
          },
        },
        {
          node: {
            title: 'أسئلة وأجوبة',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/ar/faq/',
              title: '',
              uri: 'internal:/faq',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 3,
            drupal_id: 'd33ab6ec-6d42-4e92-bc32-afa4b9ee1f50',
            drupal_parent_menu_item:
              'menu_link_content:f4c94f5e-0490-432b-bd72-2624a6f26652',
          },
        },
        {
          node: {
            title: 'القيادة',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/arcompany/leadership/',
              title: '',
              uri: 'internal:/company/leadership',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 1,
            drupal_id: '63251eb3-79c0-40d6-8d4d-97d18b6d23d3',
            drupal_parent_menu_item:
              'menu_link_content:890ea76f-a6aa-46a2-bfca-87b6dad8ed5c',
          },
        },
        {
          node: {
            title: 'الاستدامة',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/ar/sustainability/',
              title: '',
              uri: 'internal:/sustainability',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 2,
            drupal_id: 'b75be3b3-7955-4a53-ab16-a05540ae61ea',
            drupal_parent_menu_item:
              'menu_link_content:890ea76f-a6aa-46a2-bfca-87b6dad8ed5c',
          },
        },
        {
          node: {
            title: 'المستثمرون',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: 'https://ir.lucidmotors.com',
              title: '',
              uri: 'https://ir.lucidmotors.com',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 2,
            drupal_id: '9c26bca7-78a1-44d3-9d5c-658b6f45fa32',
            drupal_parent_menu_item:
              'menu_link_content:2c6a2fbd-f076-4af4-bc9b-e314c2078dd8',
          },
        },
        {
          node: {
            title: 'حسابي',
            link: {
              options: {
                attributes: {
                  type: 'auth',
                  ifUser: 'show',
                  ifSidebar: 'show',
                  ifMainNav: 'show',
                },
              },
              uri_alias: '/arportal/reservations/',
              title: '',
              uri: 'internal:/portal/reservations/',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 1,
            drupal_id: '7efc65bc-9d71-4687-94e1-457ac5f04ab5',
            drupal_parent_menu_item:
              'menu_link_content:5ca1e8eb-65d1-4621-a059-acb8653d2a99',
          },
        },
        {
          node: {
            title: 'خروج',
            link: {
              options: {
                attributes: {
                  type: 'auth',
                  ifUser: 'show',
                  ifSidebar: 'show',
                  ifMainNav: 'hide',
                },
              },
              uri_alias: '/arportal/logout/',
              title: '',
              uri: 'internal:/portal/logout/',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 2,
            drupal_id: '190c7950-d78c-4001-aa75-af2193e488e8',
            drupal_parent_menu_item:
              'menu_link_content:5ca1e8eb-65d1-4621-a059-acb8653d2a99',
          },
        },
        {
          node: {
            title: 'الأحداث',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/ar/events/',
              title: '',
              uri: 'internal:/events',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 2,
            drupal_id: '03ef38ad-586f-4afa-8679-d05a9db6a7d2',
            drupal_parent_menu_item:
              'menu_link_content:1ad280f6-2173-4ddc-999d-4b7f0ff0da52',
          },
        },
        {
          node: {
            title: 'فرص العمل',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/ar/careers/',
              title: '',
              uri: 'internal:/careers',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 4,
            drupal_id: '14da123d-a711-4103-b9ed-bbf48721493f',
            drupal_parent_menu_item:
              'menu_link_content:2c6a2fbd-f076-4af4-bc9b-e314c2078dd8',
          },
        },
        {
          node: {
            title: 'التواصل',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/ar/contact/',
              title: '',
              uri: 'internal:/contact',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 0,
            drupal_id: 'dd03d8cd-32b6-4463-802e-1388b982aa1a',
            drupal_parent_menu_item:
              'menu_link_content:1ad280f6-2173-4ddc-999d-4b7f0ff0da52',
          },
        },
        {
          node: {
            title: 'ابحث عن المعارض ومراكز الخدمة',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/ar/locations/',
              title: '',
              uri: 'internal:/locations',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 1,
            drupal_id: '7906b581-669a-469b-a9f1-5a58cba21b34',
            drupal_parent_menu_item:
              'menu_link_content:1ad280f6-2173-4ddc-999d-4b7f0ff0da52',
          },
        },
        {
          node: {
            title: 'غرفة الأخبار',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/ar/media-room/',
              title: '',
              uri: 'internal:/media-room',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 0,
            drupal_id: '790a49d8-3e7e-479d-9570-b03d80763e8f',
            drupal_parent_menu_item:
              'menu_link_content:6b4e7206-e25c-4a67-af7d-572b935ffde2',
          },
        },
        {
          node: {
            title: 'من نحن',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/ar/company/',
              title: '',
              uri: 'internal:/company',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 0,
            drupal_id: 'a6c06a9d-65fa-4ebf-ae1b-cf2f08bfbb49',
            drupal_parent_menu_item:
              'menu_link_content:890ea76f-a6aa-46a2-bfca-87b6dad8ed5c',
          },
        },
        {
          node: {
            title: 'ابق على اطلاع',
            link: {
              options: {
                attributes: {
                  type: 'button',
                  ifUser: 'show',
                  ifSidebar: 'show',
                  ifMainNav: 'show',
                },
              },
              uri_alias: '/ar/subscribe/',
              title: '',
              uri: 'internal:/subscribe',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 3,
            drupal_id: '3eca708b-8ee5-4fa8-808e-659e76634752',
            drupal_parent_menu_item:
              'menu_link_content:5ca1e8eb-65d1-4621-a059-acb8653d2a99',
          },
        },
        {
          node: {
            title: 'صمم سيارتك',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/arair/configure/',
              title: '',
              uri: 'internal:/air/configure',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'ar',
            weight: 1,
            drupal_id: '0fe4947c-18ce-499a-a0fe-a26d4af5a901',
            drupal_parent_menu_item:
              'menu_link_content:8f7a8cdb-52e1-4ebe-86f7-0b77c2aca153',
          },
        },
        {
          node: {
            title: 'Lucid Air',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/fr-ca/air/',
              title: '',
              uri: 'internal:/air',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 0,
            drupal_id: '9dc52a74-08c2-42ed-9a23-6c276b21329e',
            drupal_parent_menu_item:
              'menu_link_content:8f7a8cdb-52e1-4ebe-86f7-0b77c2aca153',
          },
        },
        {
          node: {
            title: 'En savoir plus sur Lucid',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: 'route:<nolink>',
              title: '',
              uri: 'route:<nolink>',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 0,
            drupal_id: 'f4c94f5e-0490-432b-bd72-2624a6f26652',
            drupal_parent_menu_item:
              'menu_link_content:2c6a2fbd-f076-4af4-bc9b-e314c2078dd8',
          },
        },
        {
          node: {
            title: 'Entreprise',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: 'route:<nolink>',
              title: '',
              uri: 'route:<nolink>',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 1,
            drupal_id: '890ea76f-a6aa-46a2-bfca-87b6dad8ed5c',
            drupal_parent_menu_item:
              'menu_link_content:2c6a2fbd-f076-4af4-bc9b-e314c2078dd8',
          },
        },
        {
          node: {
            title: 'Juridique',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/fr-ca/legal/',
              title: '',
              uri: 'internal:/legal',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 1,
            drupal_id: '309e1c8c-5153-43c6-9ea3-d536d25e4a5e',
            drupal_parent_menu_item:
              'menu_link_content:6b4e7206-e25c-4a67-af7d-572b935ffde2',
          },
        },
        {
          node: {
            title: 'Connectez-vous',
            link: {
              options: {
                attributes: {
                  type: 'auth',
                  ifUser: 'hide',
                  ifSidebar: 'show',
                  ifMainNav: 'show',
                },
              },
              uri_alias: '/fr-caportal/login/',
              title: '',
              uri: 'internal:/portal/login/',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 0,
            drupal_id: '4da7be9b-95e0-4839-8665-e6f5cd6284b5',
            drupal_parent_menu_item:
              'menu_link_content:5ca1e8eb-65d1-4621-a059-acb8653d2a99',
          },
        },
        {
          node: {
            title: 'Aperçu',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/fr-ca/air/',
              title: '',
              uri: 'internal:/air',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 0,
            drupal_id: 'd9468a26-c750-49a0-9b10-6e5409ca0aa4',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            title: 'Conception',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/fr-caair/design/',
              title: '',
              uri: 'internal:/air/design',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 1,
            drupal_id: 'ba4e7a33-7871-406e-b25e-c58dd304f53a',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            title: 'Recharge',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/fr-ca/charging/',
              title: '',
              uri: 'internal:/charging',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 3,
            drupal_id: 'ff275cd6-ebde-47a1-9364-f7a975da5996',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            title: 'Performance',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/fr-caair/performance/',
              title: '',
              uri: 'internal:/air/performance',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 2,
            drupal_id: '7b89f3bf-7277-412e-91d0-29b980f2bd8d',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            title: 'Connectivité',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/fr-caair/connectivity/',
              title: '',
              uri: 'internal:/air/connectivity',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 4,
            drupal_id: 'fc3e6ba6-447c-460e-bcce-c7921407b834',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            title: 'Spécifications',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/fr-caair/specs/',
              title: '',
              uri: 'internal:/air/specs',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 5,
            drupal_id: 'abead162-0e54-40b7-8dcd-7d076cc9a9c2',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            title: 'Dream Edition',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/fr-caair/dream-edition/',
              title: '',
              uri: 'internal:/air/dream-edition',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 6,
            drupal_id: '9f22f244-b91b-43fb-b25e-81932ca46c75',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            title: 'Réservez',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/fr-caair/reserve/',
              title: '',
              uri: 'internal:/air/reserve',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 2,
            drupal_id: '161eb1b4-5727-48f6-882b-dbdf8734f988',
            drupal_parent_menu_item:
              'menu_link_content:8f7a8cdb-52e1-4ebe-86f7-0b77c2aca153',
          },
        },
        {
          node: {
            title: 'Histoires',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/fr-ca/stories/',
              title: '',
              uri: 'internal:/stories',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 3,
            drupal_id: '224c0dc8-f91e-49a4-9a1f-d2b096313f3d',
            drupal_parent_menu_item:
              'menu_link_content:2c6a2fbd-f076-4af4-bc9b-e314c2078dd8',
          },
        },
        {
          node: {
            title: 'Une performance éprouvée en piste',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/fr-ca/race-proven/',
              title: '',
              uri: 'internal:/race-proven',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 0,
            drupal_id: '58b9d8cc-4ca4-4076-9999-b2ff5c81f128',
            drupal_parent_menu_item:
              'menu_link_content:f4c94f5e-0490-432b-bd72-2624a6f26652',
          },
        },
        {
          node: {
            title: 'Achat et propriété',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/fr-ca/ownership/',
              title: '',
              uri: 'internal:/ownership',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 1,
            drupal_id: 'e43609a4-ae62-44f2-b9e8-f031e31c8ee1',
            drupal_parent_menu_item:
              'menu_link_content:f4c94f5e-0490-432b-bd72-2624a6f26652',
          },
        },
        {
          node: {
            title: 'Projet Gravity',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/fr-ca/future-models/',
              title: '',
              uri: 'internal:/future-models',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 2,
            drupal_id: '0d82a0b8-b724-4b30-bada-6fd1a0ba32b5',
            drupal_parent_menu_item:
              'menu_link_content:f4c94f5e-0490-432b-bd72-2624a6f26652',
          },
        },
        {
          node: {
            title: 'FAQ',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/fr-ca/faq/',
              title: '',
              uri: 'internal:/faq',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 3,
            drupal_id: 'd33ab6ec-6d42-4e92-bc32-afa4b9ee1f50',
            drupal_parent_menu_item:
              'menu_link_content:f4c94f5e-0490-432b-bd72-2624a6f26652',
          },
        },
        {
          node: {
            title: 'Leadership',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/fr-cacompany/leadership/',
              title: '',
              uri: 'internal:/company/leadership',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 1,
            drupal_id: '63251eb3-79c0-40d6-8d4d-97d18b6d23d3',
            drupal_parent_menu_item:
              'menu_link_content:890ea76f-a6aa-46a2-bfca-87b6dad8ed5c',
          },
        },
        {
          node: {
            title: 'Développement durable',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/fr-ca/sustainability/',
              title: '',
              uri: 'internal:/sustainability',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 2,
            drupal_id: 'b75be3b3-7955-4a53-ab16-a05540ae61ea',
            drupal_parent_menu_item:
              'menu_link_content:890ea76f-a6aa-46a2-bfca-87b6dad8ed5c',
          },
        },
        {
          node: {
            title: 'Investisseurs',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: 'https://ir.lucidmotors.com',
              title: '',
              uri: 'https://ir.lucidmotors.com',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 2,
            drupal_id: '9c26bca7-78a1-44d3-9d5c-658b6f45fa32',
            drupal_parent_menu_item:
              'menu_link_content:2c6a2fbd-f076-4af4-bc9b-e314c2078dd8',
          },
        },
        {
          node: {
            title: 'Mon compte',
            link: {
              options: {
                attributes: {
                  type: 'auth',
                  ifUser: 'show',
                  ifSidebar: 'show',
                  ifMainNav: 'show',
                },
              },
              uri_alias: '/fr-caportal/reservations/',
              title: '',
              uri: 'internal:/portal/reservations/',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 1,
            drupal_id: '7efc65bc-9d71-4687-94e1-457ac5f04ab5',
            drupal_parent_menu_item:
              'menu_link_content:5ca1e8eb-65d1-4621-a059-acb8653d2a99',
          },
        },
        {
          node: {
            title: 'Se déconnecter',
            link: {
              options: {
                attributes: {
                  type: 'auth',
                  ifUser: 'show',
                  ifSidebar: 'show',
                  ifMainNav: 'hide',
                },
              },
              uri_alias: '/fr-caportal/logout/',
              title: '',
              uri: 'internal:/portal/logout/',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 2,
            drupal_id: '190c7950-d78c-4001-aa75-af2193e488e8',
            drupal_parent_menu_item:
              'menu_link_content:5ca1e8eb-65d1-4621-a059-acb8653d2a99',
          },
        },
        {
          node: {
            title: 'Événements',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/fr-ca/events/',
              title: '',
              uri: 'internal:/events',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 2,
            drupal_id: '03ef38ad-586f-4afa-8679-d05a9db6a7d2',
            drupal_parent_menu_item:
              'menu_link_content:1ad280f6-2173-4ddc-999d-4b7f0ff0da52',
          },
        },
        {
          node: {
            title: 'Carrières',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/fr-ca/careers/',
              title: '',
              uri: 'internal:/careers',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 4,
            drupal_id: '14da123d-a711-4103-b9ed-bbf48721493f',
            drupal_parent_menu_item:
              'menu_link_content:2c6a2fbd-f076-4af4-bc9b-e314c2078dd8',
          },
        },
        {
          node: {
            title: 'Contact',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/fr-ca/contact/',
              title: '',
              uri: 'internal:/contact',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 0,
            drupal_id: 'dd03d8cd-32b6-4463-802e-1388b982aa1a',
            drupal_parent_menu_item:
              'menu_link_content:1ad280f6-2173-4ddc-999d-4b7f0ff0da52',
          },
        },
        {
          node: {
            title: 'Établissements',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/fr-ca/locations/',
              title: '',
              uri: 'internal:/locations',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 1,
            drupal_id: '7906b581-669a-469b-a9f1-5a58cba21b34',
            drupal_parent_menu_item:
              'menu_link_content:1ad280f6-2173-4ddc-999d-4b7f0ff0da52',
          },
        },
        {
          node: {
            title: 'Salle des médias',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/fr-ca/media-room/',
              title: '',
              uri: 'internal:/media-room',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 0,
            drupal_id: '790a49d8-3e7e-479d-9570-b03d80763e8f',
            drupal_parent_menu_item:
              'menu_link_content:6b4e7206-e25c-4a67-af7d-572b935ffde2',
          },
        },
        {
          node: {
            title: 'À propos de nous',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/fr-ca/company/',
              title: '',
              uri: 'internal:/company',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 0,
            drupal_id: 'a6c06a9d-65fa-4ebf-ae1b-cf2f08bfbb49',
            drupal_parent_menu_item:
              'menu_link_content:890ea76f-a6aa-46a2-bfca-87b6dad8ed5c',
          },
        },
        {
          node: {
            title: 'Restez à jour',
            link: {
              options: {
                attributes: {
                  type: 'button',
                  ifUser: 'show',
                  ifSidebar: 'show',
                  ifMainNav: 'show',
                },
              },
              uri_alias: '/fr-ca/subscribe/',
              title: '',
              uri: 'internal:/subscribe',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 3,
            drupal_id: '3eca708b-8ee5-4fa8-808e-659e76634752',
            drupal_parent_menu_item:
              'menu_link_content:5ca1e8eb-65d1-4621-a059-acb8653d2a99',
          },
        },
        {
          node: {
            title: 'Concevez la vôtre',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/fr-caair/configure/',
              title: '',
              uri: 'internal:/air/configure',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'fr-ca',
            weight: 1,
            drupal_id: '0fe4947c-18ce-499a-a0fe-a26d4af5a901',
            drupal_parent_menu_item:
              'menu_link_content:8f7a8cdb-52e1-4ebe-86f7-0b77c2aca153',
          },
        },
        {
          node: {
            title: 'Lucid Air',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/nl-nl/air/',
              title: '',
              uri: 'internal:/air',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 0,
            drupal_id: '9dc52a74-08c2-42ed-9a23-6c276b21329e',
            drupal_parent_menu_item:
              'menu_link_content:8f7a8cdb-52e1-4ebe-86f7-0b77c2aca153',
          },
        },
        {
          node: {
            title: 'Meer over Lucid',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: 'route:<nolink>',
              title: '',
              uri: 'route:<nolink>',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 0,
            drupal_id: 'f4c94f5e-0490-432b-bd72-2624a6f26652',
            drupal_parent_menu_item:
              'menu_link_content:2c6a2fbd-f076-4af4-bc9b-e314c2078dd8',
          },
        },
        {
          node: {
            title: 'Bedrijf',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: 'route:<nolink>',
              title: '',
              uri: 'route:<nolink>',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 1,
            drupal_id: '890ea76f-a6aa-46a2-bfca-87b6dad8ed5c',
            drupal_parent_menu_item:
              'menu_link_content:2c6a2fbd-f076-4af4-bc9b-e314c2078dd8',
          },
        },
        {
          node: {
            title: 'Juridisch',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/nl-nl/legal/',
              title: '',
              uri: 'internal:/legal',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 1,
            drupal_id: '309e1c8c-5153-43c6-9ea3-d536d25e4a5e',
            drupal_parent_menu_item:
              'menu_link_content:6b4e7206-e25c-4a67-af7d-572b935ffde2',
          },
        },
        {
          node: {
            title: 'Aanmelden',
            link: {
              options: {
                attributes: {
                  type: 'auth',
                  ifUser: 'hide',
                  ifSidebar: 'show',
                  ifMainNav: 'show',
                },
              },
              uri_alias: '/nl-nlportal/login/',
              title: '',
              uri: 'internal:/portal/login/',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 0,
            drupal_id: '4da7be9b-95e0-4839-8665-e6f5cd6284b5',
            drupal_parent_menu_item:
              'menu_link_content:5ca1e8eb-65d1-4621-a059-acb8653d2a99',
          },
        },
        {
          node: {
            title: 'Overzicht',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/nl-nl/air/',
              title: '',
              uri: 'internal:/air',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 0,
            drupal_id: 'd9468a26-c750-49a0-9b10-6e5409ca0aa4',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            title: 'Ontwerp',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/nl-nlair/design/',
              title: '',
              uri: 'internal:/air/design',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 1,
            drupal_id: 'ba4e7a33-7871-406e-b25e-c58dd304f53a',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            title: 'Opladen',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/nl-nl/charging/',
              title: '',
              uri: 'internal:/charging',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 3,
            drupal_id: 'ff275cd6-ebde-47a1-9364-f7a975da5996',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            title: 'Prestaties',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/nl-nlair/performance/',
              title: '',
              uri: 'internal:/air/performance',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 2,
            drupal_id: '7b89f3bf-7277-412e-91d0-29b980f2bd8d',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            title: 'Connectiviteit',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/nl-nlair/connectivity/',
              title: '',
              uri: 'internal:/air/connectivity',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 4,
            drupal_id: 'fc3e6ba6-447c-460e-bcce-c7921407b834',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            title: 'Specificaties',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/nl-nlair/specs/',
              title: '',
              uri: 'internal:/air/specs',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 5,
            drupal_id: 'abead162-0e54-40b7-8dcd-7d076cc9a9c2',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            title: 'Dream Edition',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/nl-nlair/dream-edition/',
              title: '',
              uri: 'internal:/air/dream-edition',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 6,
            drupal_id: '9f22f244-b91b-43fb-b25e-81932ca46c75',
            drupal_parent_menu_item:
              'menu_link_content:9dc52a74-08c2-42ed-9a23-6c276b21329e',
          },
        },
        {
          node: {
            title: 'Reserveren',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/nl-nlair/reserve/',
              title: '',
              uri: 'internal:/air/reserve',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 2,
            drupal_id: '161eb1b4-5727-48f6-882b-dbdf8734f988',
            drupal_parent_menu_item:
              'menu_link_content:8f7a8cdb-52e1-4ebe-86f7-0b77c2aca153',
          },
        },
        {
          node: {
            title: 'Verhalen',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/nl-nl/stories/',
              title: '',
              uri: 'internal:/stories',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 3,
            drupal_id: '224c0dc8-f91e-49a4-9a1f-d2b096313f3d',
            drupal_parent_menu_item:
              'menu_link_content:2c6a2fbd-f076-4af4-bc9b-e314c2078dd8',
          },
        },
        {
          node: {
            title: 'Bewezen prestaties',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/nl-nl/race-proven/',
              title: '',
              uri: 'internal:/race-proven',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 0,
            drupal_id: '58b9d8cc-4ca4-4076-9999-b2ff5c81f128',
            drupal_parent_menu_item:
              'menu_link_content:f4c94f5e-0490-432b-bd72-2624a6f26652',
          },
        },
        {
          node: {
            title: 'Aanschaf en eigendom',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/nl-nl/ownership/',
              title: '',
              uri: 'internal:/ownership',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 1,
            drupal_id: 'e43609a4-ae62-44f2-b9e8-f031e31c8ee1',
            drupal_parent_menu_item:
              'menu_link_content:f4c94f5e-0490-432b-bd72-2624a6f26652',
          },
        },
        {
          node: {
            title: 'Project Gravity',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/nl-nl/future-models/',
              title: '',
              uri: 'internal:/future-models',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 2,
            drupal_id: '0d82a0b8-b724-4b30-bada-6fd1a0ba32b5',
            drupal_parent_menu_item:
              'menu_link_content:f4c94f5e-0490-432b-bd72-2624a6f26652',
          },
        },
        {
          node: {
            title: 'FAQ',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/nl-nl/faq/',
              title: '',
              uri: 'internal:/faq',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 3,
            drupal_id: 'd33ab6ec-6d42-4e92-bc32-afa4b9ee1f50',
            drupal_parent_menu_item:
              'menu_link_content:f4c94f5e-0490-432b-bd72-2624a6f26652',
          },
        },
        {
          node: {
            title: 'Leiderschap',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/nl-nlcompany/leadership/',
              title: '',
              uri: 'internal:/company/leadership',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 1,
            drupal_id: '63251eb3-79c0-40d6-8d4d-97d18b6d23d3',
            drupal_parent_menu_item:
              'menu_link_content:890ea76f-a6aa-46a2-bfca-87b6dad8ed5c',
          },
        },
        {
          node: {
            title: 'Duurzaamheid',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/nl-nl/sustainability/',
              title: '',
              uri: 'internal:/sustainability',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 2,
            drupal_id: 'b75be3b3-7955-4a53-ab16-a05540ae61ea',
            drupal_parent_menu_item:
              'menu_link_content:890ea76f-a6aa-46a2-bfca-87b6dad8ed5c',
          },
        },
        {
          node: {
            title: 'Investeerders',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: 'https://ir.lucidmotors.com',
              title: '',
              uri: 'https://ir.lucidmotors.com',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 2,
            drupal_id: '9c26bca7-78a1-44d3-9d5c-658b6f45fa32',
            drupal_parent_menu_item:
              'menu_link_content:2c6a2fbd-f076-4af4-bc9b-e314c2078dd8',
          },
        },
        {
          node: {
            title: 'Mijn account',
            link: {
              options: {
                attributes: {
                  type: 'auth',
                  ifUser: 'show',
                  ifSidebar: 'show',
                  ifMainNav: 'show',
                },
              },
              uri_alias: '/nl-nlportal/reservations/',
              title: '',
              uri: 'internal:/portal/reservations/',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 1,
            drupal_id: '7efc65bc-9d71-4687-94e1-457ac5f04ab5',
            drupal_parent_menu_item:
              'menu_link_content:5ca1e8eb-65d1-4621-a059-acb8653d2a99',
          },
        },
        {
          node: {
            title: 'Afmelden',
            link: {
              options: {
                attributes: {
                  type: 'auth',
                  ifUser: 'show',
                  ifSidebar: 'show',
                  ifMainNav: 'hide',
                },
              },
              uri_alias: '/nl-nlportal/logout/',
              title: '',
              uri: 'internal:/portal/logout/',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 2,
            drupal_id: '190c7950-d78c-4001-aa75-af2193e488e8',
            drupal_parent_menu_item:
              'menu_link_content:5ca1e8eb-65d1-4621-a059-acb8653d2a99',
          },
        },
        {
          node: {
            title: 'Evenementen',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/nl-nl/events/',
              title: '',
              uri: 'internal:/events',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 2,
            drupal_id: '03ef38ad-586f-4afa-8679-d05a9db6a7d2',
            drupal_parent_menu_item:
              'menu_link_content:1ad280f6-2173-4ddc-999d-4b7f0ff0da52',
          },
        },
        {
          node: {
            title: 'Vacatures',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/nl-nl/careers/',
              title: '',
              uri: 'internal:/careers',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 4,
            drupal_id: '14da123d-a711-4103-b9ed-bbf48721493f',
            drupal_parent_menu_item:
              'menu_link_content:2c6a2fbd-f076-4af4-bc9b-e314c2078dd8',
          },
        },
        {
          node: {
            title: 'Contact',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/nl-nl/contact/',
              title: '',
              uri: 'internal:/contact',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 0,
            drupal_id: 'dd03d8cd-32b6-4463-802e-1388b982aa1a',
            drupal_parent_menu_item:
              'menu_link_content:1ad280f6-2173-4ddc-999d-4b7f0ff0da52',
          },
        },
        {
          node: {
            title: 'Vestigingen',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/nl-nl/locations/',
              title: '',
              uri: 'internal:/locations',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 1,
            drupal_id: '7906b581-669a-469b-a9f1-5a58cba21b34',
            drupal_parent_menu_item:
              'menu_link_content:1ad280f6-2173-4ddc-999d-4b7f0ff0da52',
          },
        },
        {
          node: {
            title: 'Laatste nieuws/updates',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/nl-nl/media-room/',
              title: '',
              uri: 'internal:/media-room',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 0,
            drupal_id: '790a49d8-3e7e-479d-9570-b03d80763e8f',
            drupal_parent_menu_item:
              'menu_link_content:6b4e7206-e25c-4a67-af7d-572b935ffde2',
          },
        },
        {
          node: {
            title: 'Over ons',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/nl-nl/company/',
              title: '',
              uri: 'internal:/company',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 0,
            drupal_id: 'a6c06a9d-65fa-4ebf-ae1b-cf2f08bfbb49',
            drupal_parent_menu_item:
              'menu_link_content:890ea76f-a6aa-46a2-bfca-87b6dad8ed5c',
          },
        },
        {
          node: {
            title: 'Blijf op de hoogte',
            link: {
              options: {
                attributes: {
                  type: 'button',
                  ifUser: 'show',
                  ifSidebar: 'show',
                  ifMainNav: 'show',
                },
              },
              uri_alias: '/nl-nl/subscribe/',
              title: '',
              uri: 'internal:/subscribe',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 3,
            drupal_id: '3eca708b-8ee5-4fa8-808e-659e76634752',
            drupal_parent_menu_item:
              'menu_link_content:5ca1e8eb-65d1-4621-a059-acb8653d2a99',
          },
        },
        {
          node: {
            title: 'Configureren',
            link: {
              options: {
                attributes: {
                  type: null,
                  ifUser: null,
                  ifSidebar: null,
                  ifMainNav: null,
                },
              },
              uri_alias: '/nl-nlair/configure/',
              title: '',
              uri: 'internal:/air/configure',
              uri_uuid: '',
            },
            expanded: false,
            menu_name: '2021-header-nav',
            langcode: 'nl-nl',
            weight: 1,
            drupal_id: '0fe4947c-18ce-499a-a0fe-a26d4af5a901',
            drupal_parent_menu_item:
              'menu_link_content:8f7a8cdb-52e1-4ebe-86f7-0b77c2aca153',
          },
        },
      ],
    },
  };

  const recursive = (item, collection) => {
    let children = collection
      .filter(
        child =>
          typeof child.drupal_parent_menu_item === 'string' &&
          child.drupal_parent_menu_item.indexOf(item.drupal_id) !== -1
      )
      .sort((a, b) => a.weight - b.weight);

    if (children && children.length > 0) {
      children = children.map(child => recursive(child, collection));
    }

    return {
      ...item,
      children,
    };
  };

  const { edges } = result.allMenuLinkContentMenuLinkContent;
  const nodes = edges.map(edge => edge.node);
  const root = nodes.slice(0, 5).sort((a, b) => a.weight - b.weight);
  const translated = filterNodesByLangcode(nodes, langcode);

  const groups = root.map(item => recursive(item, translated));
  const lists = groups.map((list, index) => ({
    ...list,
    type: index === 0 || index === groups.length - 1 ? 'small' : 'large',
  }));

  return lists;
}

/**
 *
 * For classes
 *
 */
export const withSidebarNavigation = Component =>
  Object.assign(
    props => {
      const lists = useSidebarNavigation();
      return <Component lists={lists} {...props} />;
    },
    { displayName: 'withSidebarNavigation' }
  );
